export const config = {
  adsEnabled: import.meta.env.VITE_ADS_ENABLED === 'true',
  publicLaunchAt: import.meta.env.VITE_PUBLIC_LAUNCH_AT || '',
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || '1x00000000000000000000AA',
  recentLimit: 50,
};
